module.exports = __webpack_public_path__ + "img/logo_black.403dfd03.png";